import { createContext, type ReactNode, useContext } from 'react'
import type { SectionsConfig } from './types/NavigationSectionsConfig'

const NavigationSectionsContext = createContext<SectionsConfig | null>(null)

type NavigationSectionsProviderProps = {
  sections: SectionsConfig
  children: ReactNode
}

/**
 * Makes the app's navigation sections available anywhere inside the
 * authenticated shell. Areas can consume them via `useNavigationSectionsContext`
 * to build quick-navigation (e.g. the welcome page's inline search) from the
 * same source the navigation drawer and command palette use.
 */
export const NavigationSectionsProvider = ({
  sections,
  children,
}: NavigationSectionsProviderProps) => (
  <NavigationSectionsContext.Provider value={sections}>
    {children}
  </NavigationSectionsContext.Provider>
)

/**
 * Returns the navigation sections provided by the authenticated shell, or an
 * empty config when rendered outside a provider.
 */
export const useNavigationSectionsContext = (): SectionsConfig =>
  useContext(NavigationSectionsContext) ?? []
